import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import CustomModal from "../modal/modal.component";

export const CAN_ENTER_EVERY_COUNTER_VALUE_PERMISSION = "settlement.can_enter_every_value";

export interface LowCounterValueWarning {
  key: string;
  label: string;
  enteredValue: number;
  latestValue: number;
  latestDate?: string;
}

export const parseCounterNumericValue = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsed = Number(
    String(value)
      .trim()
      .replace(/[\s\u00A0\u202F]/g, "")
      .replace(",", ".")
  );
  return Number.isFinite(parsed) ? parsed : null;
};

interface LowCounterValueConfirmModalProps {
  opened: boolean;
  setOpened: (value: boolean) => void;
  warnings: LowCounterValueWarning[];
  onConfirm: () => void;
}

export const LowCounterValueConfirmModal = ({
  opened,
  setOpened,
  warnings,
  onConfirm,
}: LowCounterValueConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      opened={opened}
      setOpened={setOpened}
      title={t("Confirm counter value")}
      width={480}
      content={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography variant="body1">
            {t(
              "Are you sure you want to enter a counter value lower than the latest recorded value?"
            )}
          </Typography>
          {warnings.map((warning) => (
            <Alert key={warning.key} severity="warning" sx={{ alignItems: "flex-start" }}>
              <Typography variant="body2" component="div">
                <strong>{warning.label}</strong>
                <br />
                {t("Entered value")}: {warning.enteredValue}
                <br />
                {t("Latest value")}: {warning.latestValue}
                {warning.latestDate ? ` (${warning.latestDate})` : ""}
              </Typography>
            </Alert>
          ))}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, flexWrap: "wrap" }}>
            <Button variant="outlined" onClick={() => setOpened(false)}>
              {t("Cancel")}
            </Button>
            <Button
              variant="contained"
              color="warning"
              onClick={() => {
                setOpened(false);
                onConfirm();
              }}
            >
              {t("Confirm")}
            </Button>
          </Box>
        </Box>
      }
    />
  );
};
